export type ScreenKey =
  | 'cc_dashboard'
  | 'cc_analytics'
  | 'cc_hunt_logs'
  | 'cc_members'
  | 'cc_reports'
  | 'member_ledger'
  | 'season_archives'

export const CC_SCREEN_ROUTES: Readonly<Record<string, ScreenKey>> = {
  '/dashboard': 'cc_dashboard',
  '/analytics': 'cc_analytics',
  '/hunt-logs': 'cc_hunt_logs',
  '/members': 'cc_members',
  '/reports': 'cc_reports',
  '/finances/member-ledger': 'member_ledger',
  '/historical': 'season_archives',
}

export function resolveScreenKey(pathname: string): ScreenKey | null {
  let normalized = pathname.split('?')[0].split('#')[0]
  while (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1)
  }
  return CC_SCREEN_ROUTES[normalized] ?? null
}
